<script setup lang="ts">
import type { FormValues } from './schema';

import type { UiSearchBaseInputEntry, UiSearchFieldKey } from '@/ui/Search/types';
import Search from '@/ui/Search/index.vue';
import {
  searchCreatedBy,
  searchCreationTime,
  searchID,
  searchLastUpdateBy,
  searchLastUpdateTime,
} from '~/components/harmon/search/inputs';

const values = defineModel<FormValues>('values', { required: true });

const searchSize: UiSearchBaseInputEntry<'size'> = {
  name: 'size',
  type: 'number',
  field: { label: 'Size (bytes)' },
  input: { placeholder: 'Type a size and press Enter' },
  icon: ['fal', 'database'],
};

const inputs = computed<UiSearchBaseInputEntry<UiSearchFieldKey<FormValues>>[]>(() => [
  {
    name: 'name',
    type: 'input',
    field: { label: 'Name' },
    input: { placeholder: 'Search by file name' },
    icon: ['fal', 'file'],
    alwaysOn: true,
    operator: 'contains',
  },
  {
    name: 'originalName',
    type: 'input',
    field: { label: 'Original name' },
    input: { placeholder: 'Search by original file name' },
    icon: ['fal', 'file-alt'],
  },
  {
    name: 'mimeType',
    type: 'input',
    field: { label: 'MIME type' },
    input: { placeholder: 'Search by MIME type' },
    icon: ['fal', 'file-code'],
  },
  {
    name: 'ext',
    type: 'input',
    field: { label: 'Extension' },
    input: { placeholder: 'Search by extension' },
    icon: ['fal', 'file-archive'],
  },
  {
    name: 'path',
    type: 'input',
    field: { label: 'Path' },
    input: { placeholder: 'Search by path' },
    icon: ['fal', 'folder'],
  },
  {
    name: 'uri',
    type: 'input',
    field: { label: 'URI' },
    input: { placeholder: 'Search by URI' },
    icon: ['fal', 'link'],
  },
  searchSize,
  searchID,
  searchCreationTime,
  searchLastUpdateTime,
  searchCreatedBy,
  searchLastUpdateBy,
]);
</script>

<template>
  <Search v-model:values="values" :inputs="inputs" class="mb-4">
    <template #createdBy-input>
      <AgentsAISelectMany v-model:value="values.createdBy" />
    </template>
    <template #lastUpdateBy-input>
      <AgentsAISelectMany v-model:value="values.lastUpdateBy" />
    </template>
  </Search>
</template>
